<script>
  import { alert } from "../store";
</script>

<style>
  .wrapper {
    margin: 10px 0;
  }
</style>

{#if $alert.value }
  <div class="wrapper container is-fluid">
    <div class={`notification ${$alert.className || ""}`}>
      <button class="delete" on:click={() => alert.clear()} />
      <p>{$alert.value || ''}</p>
    </div>
  </div>
{/if}
